import { ITopology } from '../../app/apiSlice';
import { useSecureApplication } from '../../hooks/KeycloackConnection';
import { DeleteTopology } from './DeleteTopology';
import ExportTopology from './ExportTopology';
import OpenTopology from './OpenTopology';

const ActionsTopology = (topology: ITopology) => {
    const {hasAnyPerm} = useSecureApplication();
    return (
        <div
            className="flex"
            key={topology.id}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <OpenTopology topology={topology}/>
            {hasAnyPerm('pipelines.all', 'pipelines.create') && (
                <ExportTopology topology={topology}/>
            )}
            {hasAnyPerm('pipelines.all', 'pipelines.del') && (
                <DeleteTopology topology={topology}/>
            )}
        </div>
    );
};

export default ActionsTopology;
